//check if browser supports WEBP
export function isWebpSupported() {
  const elem = document.createElement('canvas');
  if (!!(elem.getContext && elem.getContext('2d'))) {
    return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
  }
  return false;
}
// Observe sections/divs for lazy loading
export function observeSections(callback) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        callback(entry.target.id);
        // observer.unobserve(entry.target); // Stop observing once the section is intersecting
      }
    });
  });
  document.querySelectorAll('.lazy-section').forEach(section => {
    observer.observe(section);
  });
  return () => {
    observer.disconnect();
  };
}

// Observe videos for lazy loading
export function observeVideos(callback) {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const video = entry.target.querySelector('video');
        if (video) {
          const source = video.querySelector('source');
          if (source && source.getAttribute('data-src')) {
            source.setAttribute('src', source.getAttribute('data-src'));
            video.load();
            callback(entry.target.id);
          }
        }
        observer.unobserve(entry.target);
      }
    });
  });

  document.querySelectorAll('.lazy-video').forEach(video => {
    observer.observe(video);
  });

  return () => {
    observer.disconnect();
  };
}

// Hash pp_ctaclr
export function hexHash(hex) {
  const hexRegex = /^[0-9a-f]*$/i;
  if (hex == null || hex.length < 6 || !hexRegex.test(hex)) {
    return `#1559ED`;
  }

  hex = hex.slice(0, 6);

  return `#${hex}`;
}

// Darken color when hovering
export function hoverDarken(hex) {
  const hexRegex = /^[0-9a-f]*$/i;
  if (hex == null || hex.length < 6 || !hexRegex.test(hex)) {
    hex = '1559ED';
  }

  let r = parseInt(hex.slice(0, 2), 16);
  let g = parseInt(hex.slice(2, 4), 16);
  let b = parseInt(hex.slice(4, 6), 16);

  r = Math.max(0, Math.min(255, r - (r * 0.15)));
  g = Math.max(0, Math.min(255, g - (g * 0.15)));
  b = Math.max(0, Math.min(255, b - (b * 0.15)));

  const toHex = (value) => {
    const hexValue = Math.round(value).toString(16);
    return hexValue.padStart(2, '0');
  };
  
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
}

export function getPrefixLocation() {
  const currentLocation = window.location.href;

  if (currentLocation.indexOf("staging") > -1) {
      return "staging.";
  } else if (currentLocation.indexOf("dev") > -1) {
      return "dev.";
  } else if (currentLocation.indexOf("uat") > -1) {
      return "uat.";
  }

  return ""
}

export function getPrefixLocationwDomain() {
  const prefix = getPrefixLocation();
  
  if (prefix) {
      return prefix + "ai-pro.org";
  }
  
  return "";
}

export function trackSignUp(method) {
  try {
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== 'function') {
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    window.dataLayer.push({ event: 'sign_up', method });
  } catch (e) {
    // ignore analytics errors
  }
}

export function consumePendingSignUpEvent() {
  const prefix = "gtag_signup_method=";
  const match = document.cookie
    .split(";")
    .map((c) => c.trim())
    .find((c) => c.startsWith(prefix));
  if (!match) return;

  const method = decodeURIComponent(match.slice(prefix.length));
  if (!method) return;

  trackSignUp(method);

  document.cookie = "gtag_signup_method=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  document.cookie = "gtag_signup_method=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.ai-pro.org;";
}